import type { ControlProps } from './types';

export function LabelControl({ schema, value, disabled, onChange }: ControlProps) {
  return (
    <input
      type="text"
      aria-label={schema.label}
      value={typeof value === 'string' ? value : ''}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}
